import type { NonEmptyString } from "app/pages/sales-intelligence/types/primitives";
import type { TypeGuard } from "app/pages/sales-intelligence/types/type-guard";

export const is: TypeGuard = {
    string: (v: unknown): v is string => typeof v === "string",
    nonEmptyString: (v: unknown): v is NonEmptyString => typeof v === "string" && v.length > 0,
    number: (v: unknown): v is number => typeof v === "number",
    undefined: (v: unknown): v is undefined => typeof v === "undefined",
    record: (v: unknown): v is Record<string, unknown> => v !== null && typeof v === "object",
    boolean: (v: unknown): v is boolean => typeof v === "boolean",
    readonlyArray: <Value>(v: unknown): v is readonly Value[] => Array.isArray(v),
    isPromise: <Value>(v: unknown): v is Promise<Value> => v instanceof Promise,
    isValidDate: (v: unknown): v is Date => v instanceof Date && !isNaN(v.getTime()),
};
